<template>
  <div>
    <div v-for="(shape, index) in shapes" :key="index">
      <div>
        {{ shape.name }}
        <v-btn ref="btn-collapse" class="ma-0" variant="text" icon size="small" @click="selected = index">
          <v-icon color="black" v-if="selected !== index">mdi-chevron-down</v-icon>
          <v-icon color="black" v-else>mdi-chevron-up</v-icon>
        </v-btn>
      </div>
      <div v-if="selected === index">
        <div v-for="(image, imgIndex) in shape.images" :key="imgIndex">
          <img :src="image" alt="" style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import oneVersant from '@/assets/toiture/1 versant.png';
import oneVersantDetailed from '@/assets/toiture/detailedPictures/1-versant.png';
import twoVersants from '@/assets/toiture/2 versants.png';
import twoVersantsDetailed from '@/assets/toiture/detailedPictures/2-versant.png';
import threeVersants from '@/assets/toiture/3 versants.png';
import threeVersantsTriangle from '@/assets/toiture/detailedPictures/3-versant_triangle.png';
import threeVersantsTrapezeRectangle from '@/assets/toiture/detailedPictures/3-versant_trapeze-rectangle.png';
import fourVersants from '@/assets/toiture/4 versants.png';
import fourVersantsTriangle from '@/assets/toiture/detailedPictures/4-versant_Triangle.png';
import fourVersantsTrapeze from '@/assets/toiture/detailedPictures/4-versant_trapeze.png';
import rectangle from '@/assets/toiture/CustomShapes/rectangle.png';
import triangle from '@/assets/toiture/CustomShapes/triangle.png';
import trapeze from '@/assets/toiture/CustomShapes/trapeze.png';
import trapezeRectangle from '@/assets/toiture/CustomShapes/trapeze_rectangle.png';
import triangleLucarne from '@/assets/toiture/CustomShapes/triangle_lucarne.png';
import trapezeLucarne from '@/assets/toiture/CustomShapes/trapeze_lucarne.png';
import rectangleLucarne from '@/assets/toiture/CustomShapes/rectangle_lucarne.png';
import lucarneThreeVersants from '@/assets/toiture/CustomShapes/lucarne_3_versants.png';

export default {
  data: () => ({
    selected: 0,
    shapes: [
      {
        name: '1 Versant',
        images: [oneVersant, oneVersantDetailed],
      },
      {
        name: '2 versants',
        images: [twoVersants, twoVersantsDetailed],
      },
      {
        name: '3 versants',
        images: [threeVersants, threeVersantsTriangle, threeVersantsTrapezeRectangle],
      },
      {
        name: '4 versants',
        images: [fourVersants, fourVersantsTriangle, fourVersantsTrapeze],
      },
      {
        name: 'Rectangle',
        images: [rectangle],
      },
      {
        name: 'Triangle',
        images: [triangle],
      },
      {
        name: 'Trapeze',
        images: [trapeze],
      },
      {
        name: 'Trapeze Rectangle',
        images: [trapezeRectangle],
      },
      {
        name: 'Triangle Lucarne',
        images: [triangleLucarne],
      },
      {
        name: 'Trapeze Lucarne',
        images: [trapezeLucarne],
      },
      {
        name: 'Rectangle Lucarne',
        images: [rectangleLucarne],
      },
      {
        name: 'Lucarne 3 versants',
        images: [lucarneThreeVersants],
      },
    ],
  }),
};
</script>

<style lang="stylus" scoped></style>
